module.exports = __webpack_public_path__ + "img/40.ea63093b.png";